import Vue from 'vue';
import locale from 'element-ui/lib/locale';
import VueI18n from 'vue-i18n';
import store from '@/store';

Vue.use(VueI18n);

// 自动加载语言文件
const langFiles = require.context('./', false, /^\.\/(?!index|ele\b).*\.js$/);
const customMessages = {};
langFiles.keys().forEach((key) => {
  const langName = key.replace(/(\.\/|\.js)/g, '');
  customMessages[langName] = langFiles(key).default;
});

const supportedLangs = Object.keys(customMessages);
const messages = {};

// 加载 Element 语言
supportedLangs.forEach((lang) => {
  let eleLang = {};
  try {
    eleLang = require(`ele-admin/packages/lang/${lang}`).default;
  } catch (e) {
    try {
      eleLang = require(`./ele/${lang}`).default;
    } catch (e) {
      eleLang = {};
    }
  }
  messages[lang] = { ...customMessages[lang], ...eleLang };
});

export const langNames = {
  en: 'English',
  ro: 'Română',
};

// 校验语言合法性
const isValidLang = (lang) => lang && supportedLangs.includes(lang);

// 核心：仅检测 当前页面 URL 的 ?lang= 参数
export const getUrlLang = () => {
  try {
    const params = new URLSearchParams(window.location.search);
    const lang = params.get('lang');
    return isValidLang(lang) ? lang : null;
  } catch {
    return null;
  }
};

// 获取浏览器语言
const getBrowserLang = () => {
  const browserLang = navigator.language || 'en';
  const lang = browserLang.split('-')[0];
  return isValidLang(lang) ? lang : 'en';
};

// ==========================================
// 【唯一修改：这里彻底去掉自动存 localStorage 的代码】
// ==========================================
export const getCurrentLang = () => {
  // 1. URL 参数
  const urlLang = getUrlLang();
  if (urlLang) {
    return urlLang; // 👈 只返回，不存缓存
  }

  // 2. 本地缓存
  const localLang = localStorage.getItem('hippoWebLang');
  if (isValidLang(localLang)) {
    return localLang; // 👈 只返回，不存缓存
  }

  // 3. 浏览器语言
  return getBrowserLang(); // 👈 只返回，不存缓存
};

// 初始化 i18n
const i18n = new VueI18n({
  locale: getCurrentLang(),
  messages,
  silentTranslationWarn: true,
});

// 切换语言
export const setLanguage = (lang) => {
  const finalLang = isValidLang(lang) ? lang : 'en';

  // 👇 只有这里唯一写入缓存！绝对不会被覆盖！
  localStorage.setItem('hippoWebLang', finalLang);

  store.commit('SET_LANGUAGE', finalLang);
  i18n.locale = finalLang;

  // ===================== 【新增：切换语言时同步更新 URL】 =====================
  const url = new URL(window.location.href);
  url.searchParams.set('lang', finalLang);
  window.history.replaceState({}, '', url.href);

  locale.i18n((key, value) => i18n.t(key, value));
};

// 初始化
const initLang = getCurrentLang();
setLanguage(initLang); // 👈 初始化时统一存一次

export { supportedLangs };
export default i18n;
